import companyData from "../../companyData";

export const list = [
  {
    id: 1,
    heading: "Why An FAQ Resource?",
    content: `Firstly, FAQ pages can bring new visitors to your website via organic search and drive them quickly to related pages – most typically deeper blog pages and service pages closely related to the questions being resolved.
  
    Next, one of the most significant opportunities for impactful brand visibility within the search engine result pages (in-SERP) is targeting audience questions, wants, needs, and pain points.`,
  },
  {
    id: 2,
    heading: `WIs there any limitation on the quantity or amount of online purchase?
    `,
    content: `No, there is no limit. The quantity that you can buy is depending on the available stock of the online purchase.`,
  },
  {
    id: 3,
    heading: `How can I get large items home?
    `,
    content: `Most ${companyData.name} products are flat-packed, making them easy to transport. The ${companyData.name} store offers (or will refer you to) a home delivery service if you prefer. Home delivery is not included in the product price.`,
  },
  {
    id: 4,
    heading: `Why are items sometimes out of stock?
    `,
    content: `Every effort is made to maintain the availability of items shown in the catalogue, but due to popularity and supply issues, some products may not always be available. Generally, ${companyData.name} can estimate when a product should be back in stock. Because ${companyData.name} products are manufactured throughout the world, there are sometimes circumstances which can cause delivery delays`,
  },
  {
    id: 5,
    heading: `What if I want to have the products assembled?
    `,
    content: `${companyData.name} products are generally easy to assemble and require no special tools. If you prefer, most ${companyData.name} stores can refer you to a reputable, reasonably priced assembly company that can come to your home to assemble and install our products.`,
  },
  {
    id: 6,
    heading: ` Is there any limitation on the quantity or amount of online purchase?
    `,
    content: `No, there is no limit. The quantity that you can buy is depending on the available stock of the online purchase.`,
  },
  {
    id: 7,
    heading: `Why FAQ Pages Are A Priority
    `,
    content: `FAQ pages continue to be a priority area for SEO and digital marketing professionals.
  
      An FAQ page is one of the simplest ways to improve your site and help site visitors and users.
      
      Your FAQ section should be seen as a constantly expanding source of value provided to your audience. It is a place where their ever-changing and growing requirements are not only met but anticipated and exceeded frequently.`,
  },
  {
    id: 8,
    heading: `What is the ${companyData.name} business idea?
    `,
    content: `The ${companyData.name} business idea is: "We shall offer a wide range of well-designed, functional home furnishing products at prices so low that as many people as possible will be able to afford them."`,
  },
  {
    id: 9,
    heading: `How does ${companyData.name} approach environmental issues?
    `,
    content: `We're working to create a better environment outdoors as well as indoors.

`,
  },
];
